import { useState, useRef, useEffect } from "react";
import { Link } from "react-scroll";
import StockChatBot from "./stock-chatbot/StockChatBot";

export default function CompanyNavbar({companysectionlist, companyinfo}) {
  
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen(prev => !prev);
  };
  return (<>
    <nav className="sticky top-0 bg-gray-50 shadow-md z-50 lg:px-4 ">
      <div className="flex gap-6 px-4 pt-3 pb-1 overflow-x-auto whitespace-nowrap">
        {companysectionlist.map((val, key) => (
        <Link
          spy={true}
          to={val?.id}
          smooth={true}
          duration={500}
          offset={-80}
          activeClass="!text-accent border-b-2 border-accent"
          className="cursor-pointer sub-nav-holder block"
          onClick={() => {
          window.history.replaceState(null, null, `#${val?.id}`);
        }}
        >
         {val?.label}
        </Link>
          ))
        }
        <div className="cursor-pointer sub-nav-holder block bg-accent !text-white px-2 rounded mb-1" onClick={() => setIsOpen(!isOpen)}>
          Ask AI
        </div>
      </div>
    </nav>
    <StockChatBot companyinfo={companyinfo} isOpen={isOpen} toggleChat={toggleChat} />
    </>
  );
}
